/**
 * SocialPanel — edits social profile URLs (builder metadata). Bound to the schema's
 * businessInfo.social, which the editor seeds from existing contact/footer links.
 */
import { useBuilderEditor, SOCIAL_PLATFORM_FIELDS } from './editorContext'
import { Fieldset, TextField } from './controls'

export function SocialPanel() {
  const e = useBuilderEditor()
  const social = e.schema.businessInfo?.social ?? {}
  return (
    <div>
      <Fieldset title="Social links">
        {SOCIAL_PLATFORM_FIELDS.map((p) => (
          <TextField
            key={p.key}
            label={p.label}
            value={social[p.key] ?? ''}
            placeholder={p.placeholder}
            onChange={(v) => e.setSocial(p.key, v)}
          />
        ))}
      </Fieldset>
    </div>
  )
}
